import { Dispatch, SetStateAction } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { format } from 'date-fns';
import { FormikHelpers } from 'formik';

import { useListagemContext } from 'context/ListagemContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { Loja } from 'pages/cadastro/loja/types';
import { useGerarReembolsoContext } from 'pages/financeiro/reembolso/gerar-reembolso/contexts';
import { FormikApuracao, Quinzena } from 'pages/financeiro/reembolso/gerar-reembolso/types';

export function useMutateReembolso({ setOpen }: { setOpen: Dispatch<SetStateAction<boolean>> }) {
    const { getFilterValues } = useListagemContext();
    const { selectedPromocoes, setFgTodasPromocoes, setSelectedPromocoes } = useGerarReembolsoContext();
    const { mutate, isLoading } = useFormMutation();
    const { cdLoja: lojas, dtInicio, dtFim } = getFilterValues();
    const queryClient = useQueryClient();

    /**
     * Realiza o envio dos dados do formulário para gerar o reembolso.
     */
    const handleSubmit = (formData: FormikApuracao, formik: FormikHelpers<FormikApuracao>) => {
        mutate(
            {
                url: '/financeiro/apuracao/gerarreembolso',
                formik,

                formData: {
                    dtFim: format(dtFim, 'MM/dd/yyyy'),
                    dtInicio: format(dtInicio, 'MM/dd/yyyy'),
                    cdLojas: lojas ? lojas.map((l: Loja) => l.cdLoja) : [],
                    nrAno: (formData.ano as Date).getFullYear(),
                    nrMes: (formData.mes as Date).getMonth() + 1,
                    nrQuinzena: (formData.quinzena as Quinzena).idQuinzena,
                    idPromocoes: Array.from(selectedPromocoes.ids).map((item) => (item as string).split('-')[0]),
                },
            },
            {
                onSuccess: () => {
                    setOpen(false);

                    formik.resetForm();

                    setFgTodasPromocoes(false);

                    setSelectedPromocoes({
                        type: 'include',
                        ids: new Set(),
                    });

                    queryClient.invalidateQueries(['queryReembolso']);
                },
            },
        );
    };

    return { handleSubmit, isLoading };
}
